import { PreloaderHandlerInterface } from './webglLoadingHandler';
import { PreloaderScreen } from '../webgl/preloaderScreen';
import { getPreloaderPercentsLayout } from './preloaderPercentsLayout';


export class NormalWebglLoadingHandler implements PreloaderHandlerInterface {
    onCompatibilityCheckFailed(): void {
        return undefined;
    }

    onPreStart(initialPercents: number): void {
        PreloaderScreen.getInstance().setLoadingProgress(initialPercents);
    }

    onClientLoadingProgressChanged(clientLoadingPercent: number): void {
        const percentsLayout = getPreloaderPercentsLayout();
        const clientLoadingPercents = percentsLayout.clientLoadingEnd - percentsLayout.clientLoadingStart;
        const currentPercent = percentsLayout.clientLoadingStart + (clientLoadingPercent / 100) * clientLoadingPercents;
        PreloaderScreen.getInstance().setLoadingProgress(currentPercent);
    }

    onCompileProgressChange(compileProgressShare: number): void {
        const percentsLayout = getPreloaderPercentsLayout();
        const currentPercent = percentsLayout.initialPercent +
            compileProgressShare * (percentsLayout.compilingEndPercent - percentsLayout.initialPercent);
        PreloaderScreen.getInstance().setLoadingProgress(currentPercent);
    }
}
